import React, { Component } from 'react'
import { StaticBox, FlowTable, Modal, LinkedInputGroup, LinkedInput, NoContentBox, LinkedToggle } from 'components/basic'
import { date, notify } from 'helpers'
import Datetime from 'react-datetime'
import { default as moment } from 'moment-timezone'
import http from 'API/http'
import { Installation } from 'config'
import ReactHtmlParser from 'react-html-parser'
import { Creatable } from 'react-select'
import CharacteristicsWidget from './CharacteristicsWidget'

class AvailableServices extends Component {
  constructor (props) {
    super(props)
    this.state = {
      access: null,
      connectionModal: false,
      filter: '',
      activationDate: null,
      serviceToConnect: {},
      commentsModal: false,
      characteristics: null,
      comments: []
    }
  }
  componentDidMount () {
    this.setServices(this.props.access)
  }
  componentWillReceiveProps (props) {
    if (props.updated === this.props.updated) return false
    this.setServices(props.access)
  }
  setServices (access) {
    this.setState({access})
  }

  getServiceAvailability (availability) {
    if (availability === 'YES') return <span className='label orders-label label-success'><b>YES</b></span>
    if (availability === 'NO') return <span className='label orders-label label-danger'><b>NO</b></span>
    return <span className='label orders-label label-primary'><b>{date.format(availability)}</b></span>
  }
  async openConnectionModal (service) {
    await this.setState({serviceToConnect: service, connectionModal: true})
    if (service.available !== 'YES' && service.available !== 'NO') this.setState({activationDate: moment(service.available)})
  }

  isDateValidActivate (current) {
    var yesterday = Datetime.moment().subtract(1, 'day')
    if (this.state.serviceToConnect.available !== 'YES' && this.state.serviceToConnect.available !== 'NO') {
      return current.isSameOrAfter(moment(this.state.serviceToConnect.available))
    }
    return current.isAfter(yesterday)
  }
  async activateService () {
    var valid = await new Promise((resolve, reject) => { this.form.check(resolve) })
    var characteristics = {}
    Object.entries(this.setCharacteristics()).map(([key, characteristic]) => {
      if (characteristic.required && characteristic.value.length === 0) {
        notify.warn('Value is required for ' + key)
        return valid = false
      }
      characteristics[key] = (characteristic.value.hasOwnProperty('value') ? characteristic.value.value : characteristic.value)
    })
    if (!valid) return
    this.setState({activating: true})
    //eslint-disable-next-line
    var [err, res] = await http.post('2.4/orders', {
      accessId: this.state.access.accessId,
      service: this.state.serviceToConnect.service,
      requestedDateTime: (this.state.activationDate ? moment(this.state.activationDate).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]') : null),
      operation: 'ACTIVATE',
      forcedTakeover: false,
      characteristics: characteristics,
      equipment: [
        { vendorId: 'CH_BROADBAND' }
      ],
      spReference: this.state.spReference,
      spSubscriptionId: this.state.spSubscriptionId
    })
    var activationDate = this.state.activationDate
    this.setState({
      activationDate: null,
      serviceToConnect: {},
      connectionModal: false,
      spReference: '',
      spSubscriptionId: '',
      activating: false
    })
    if (err) return notify.alert('', err.response.data.cause, 'error')
    notify.alert('', 'The service will be activated ' + (!activationDate ? 'soon.' : moment(activationDate).format('YYYY-MM-DD HH:mm')), 'success')
    this.props.callback()
  }
  render () {
    if (!this.state.access) return false
    return (
      <div>
        <StaticBox filter={(e) => { this.setState({ filter: e.target.value }) }} cols={12} icon='cog' title='Available Services'>
          <FlowTable filter={this.state.filter}  hideHeaders emptyIcon='fa-cog' emptyText='No Available Services' data={this.state.access.services.map(service => [
            (service.available !== 'NO' && <a onClick={e => this.openConnectionModal(service)} className='table-link'><i className='fa fa-plus' /></a>),
            this.getServiceAvailability(service.available),
            service.service,
            service.comments && service.comments.length > 1 && <a data-tip='View All Comments' onClick={e => this.setState({comments: service.comments, commentsModal: true})} className='table-link'><i className='fa fa-comments-o' /></a>,
            service.comments && service.comments[0]
          ])}>
            <tr>
              <th className='buttons' />
              <th style={{'width': '60px'}}>Available</th>
              <th>Name</th>
              <th className='buttons' />
              <th>Comment</th>
            </tr>
          </FlowTable>
        </StaticBox>
        <Modal noOverflow title={'Connect ' + this.state.serviceToConnect.service} isOpen={this.state.connectionModal} close={e => this.setState({connectionModal: false})} buttons={[
          { disabled: this.state.activating, icon: (this.state.activating ? 'fa-circle-o-notch fa-spin' : ''), text: (this.state.activating ? 'Activating' : 'Activate'), event: e => this.activateService() }
        ]}>
          <label>Activation time</label>
          <Datetime isValidDate={this.isDateValidActivate.bind(this)} value={this.state.activationDate} onChange={date => {
            this.setState({activationDate: date})
          }} dateFormat={'YYYY-MM-DD'} inputProps={{placeholder: 'As soon as possible.'}} timeFormat={'HH:mm'} renderInput={props =>
            <div className='input-group'>
              <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
              <input {...props} className='form-control' />
            </div>
          } />
          <div className='row'>
          <LinkedInputGroup ref={(form) => { this.form = form }}>
              <div className='col-md-12'>
                <label>Your Internal Reference</label>
                <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='spReference' />
              </div>
              <div className='col-md-12'>
                <label>Your Subscription ID</label>
                <LinkedInput context={this} path='spSubscriptionId' />
              </div>
          </LinkedInputGroup>
          {this.state.serviceToConnect.characteristics &&
            <CharacteristicsWidget updated={this.state.serviceToConnect.service} getCharacteristics={characteristics => (this.setCharacteristics = characteristics)} characteristics={this.state.serviceToConnect.characteristics} editable />
          }
          </div>
        </Modal>
        <Modal noOverflow icon='comments-o' title='Comments' isOpen={this.state.commentsModal} close={e => this.setState({commentsModal: false})}>
          {this.state.comments && this.state.comments.map(comment => {
            return (
              <div className='col-md-12'>
                <pre>
                  {comment}
                </pre>
              </div>
            )
          })}
        </Modal>
      </div>
    )
  }
}
export default AvailableServices



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/access/AvailableServices.js